
import { Button, ComponentStyle} from '@/imports-files/components/delete-candidate-modal';
import { closeJob, useTranslation}  from '@/imports-files/pages/clients/candidates/kanban';
import Modal from "@/components/common-modal/modal";

export function CloseJobModal({setCloseJobModal, job_id,  router, title})
{
  const {t} = useTranslation()
  return(
          <Modal
            type="confirmation"
            message={t('modal:confirmation:close_job', {name:title})}
            texts={{
              button1_text: t('button:cancel'),
              button2_text: t('button:confirm'),
            }}
            closeModal={() => setCloseJobModal(false)}
            btnAction={() => {
              closeJob(job_id, router)
            }}
          />
        )
} 

